<div class="mt-3 animated fadeIn">
  <h4 id="certifications-heading">Certifications</h4>
  <ng-container *ngIf="certifications | async | sortBy: 'desc':'effectiveDate' as items; else loading">
    <div class="table-responsive">
      <table class="table table-striped border mt-3 shadow-sm" [class.table-sm]="isMobile | async" aria-labelledby="certifications-heading">
        <caption class="sr-only">Certifications</caption>
        <thead>
          <tr>
            <th *ngFor="let head of certificationsHeadElements" scope="col">{{head}} </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let el of items">
            <td>{{ el.organizationName }}</td>
            <td>{{ el.typeOfCertification }}</td>
            <td>{{ el.specialty }}</td>
            <td>{{ el.effectiveDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
</ng-template>